import keyMirror from 'keymirror';

const ancillaryTypes = keyMirror({
  AMK: null, // Concierge
  DPI: null, // Discount pass
  MSB: null, // Extra bag
  AMS: null, // Travel insurance
  AMPLUS_UPGRADE: null,
});

const baggageTypeOptions = {
  '0IA': 'APP_STANDARD_BAG',
  '0CC': 'APP_STANDARD_BAG',
  '0CD': 'APP_STANDARD_BAG',
  '0CE': 'APP_STANDARD_BAG',
  '0CF': 'APP_STANDARD_BAG',
  '0CG': 'APP_STANDARD_BAG',
  '0CH': 'APP_STANDARD_BAG',
  '0CI': 'APP_STANDARD_BAG',
  '0CJ': 'APP_STANDARD_BAG',
  '0CK': 'APP_STANDARD_BAG',
  '0CZ': 'BAGGAGE_CARRY_ON',
  '0EN': 'APP_STANDARD_BAG',
  '0D6': 'APP_FISHING_BAG',
  '0DC': 'APP_GOLF_BAG',
  '0HT': 'APP_SKI_SNOWBOARD_BAG',
  '0EC': 'APP_BICYCLE_BAG',
  '0ED': 'APP_HUNTING_BAG',
  '0EE': 'APP_SCUBA_BAG',
  '0FR': 'APP_BOOGIE_BOARD_BAG',
  '0GD': 'APP_SURFBOARD_BAG',
  '0GI': 'APP_WINDSURF_BAG',
  '0KG': 'APP_MUSICAL_INSTRUMENT_BAG',
  '0KO': 'APP_HOCKEY_BAG',
  '0NS': 'APP_SNOWBOARD_BAG',
  '0N8': 'APP_WAKEBOARD_BAG',
  '0LX': 'APP_STANDARD_BAG_LIGHT',
  '0JH': 'APP_STANDARD_BAG_LIGHT',
  '0LL': 'APP_STANDARD_BAG_LIGHT',
  '02T': 'APP_STANDARD_BAG_LIGHT',
  'XB5': 'APP_STANDARD_BAG_LIGHT',
  'XB6': 'APP_STANDARD_BAG_LIGHT',
  'XB7': 'APP_STANDARD_BAG_LIGHT',
  '07X': 'BAGGAGE_CARRY_ON',
};

const baggageTypeOptionsInternacional = {
  '0IA': 'APP_STANDARD_BAG_INT',
  '0CC': 'APP_STANDARD_BAG_INT',
  '0CD': 'APP_STANDARD_BAG_INT',
  '0CE': 'APP_STANDARD_BAG_INT',
  '0CF': 'APP_STANDARD_BAG_INT',
  '0CG': 'APP_STANDARD_BAG_INT',
  '0CH': 'APP_STANDARD_BAG_INT',
  '0CI': 'APP_STANDARD_BAG_INT',
  '0CJ': 'APP_STANDARD_BAG_INT',
  '0CK': 'APP_STANDARD_BAG_INT',
  '0CZ': 'BAGGAGE_CARRY_ON',
  '0EN': 'APP_STANDARD_BAG_INT',
  '0D6': 'APP_FISHING_BAG',
  '0DC': 'APP_GOLF_BAG',
  '0HT': 'APP_SKI_SNOWBOARD_BAG',
  '0EC': 'APP_BICYCLE_BAG',
  '0ED': 'APP_HUNTING_BAG',
  '0EE': 'APP_SCUBA_BAG',
  '0FR': 'APP_BOOGIE_BOARD_BAG',
  '0GD': 'APP_SURFBOARD_BAG',
  '0GI': 'APP_WINDSURF_BAG',
  '0KG': 'APP_MUSICAL_INSTRUMENT_BAG',
  '0KO': 'APP_HOCKEY_BAG',
  '0NS': 'APP_SNOWBOARD_BAG',
  '0N8': 'APP_WAKEBOARD_BAG',
  '0LX': 'APP_STANDARD_BAG_LIGHT',
  '0JH': 'APP_STANDARD_BAG_LIGHT',
  '0LL': 'APP_STANDARD_BAG_LIGHT',
  '02T': 'APP_STANDARD_BAG_LIGHT',
  'XB5': 'APP_STANDARD_BAG_LIGHT',
  'XB6': 'APP_STANDARD_BAG_LIGHT',
  'XB7': 'APP_STANDARD_BAG_LIGHT',
  '07X': 'BAGGAGE_CARRY_ON',
};

const baggageTypes = keyMirror({
  '0IA': null, // No cambiar de lugar 0IA afecta la métrica de removeAdmin fee
  '0CC': null,
  '0CD': null,
  '0CE': null,
  '0CF': null,
  '0CG': null,
  '0CH': null,
  '0CI': null,
  '0CJ': null,
  '0CK': null,
  '0EN': null,
  '0D6': null,
  '0DC': null,
  '0HT': null,
  '0EC': null,
  '0ED': null,
  '0EE': null,
  '0FR': null,
  '0GD': null,
  '0GI': null,
  '0KG': null,
  '0KO': null,
  '0NS': null,
});

const baggageTypesArray = [
  '0IA', // No cambiar de lugar 0IA afecta la métrica de removeAdmin fee
  '02T',
  '0CC',
  '0CD',
  '0CE',
  '0CF',
  '0CG',
  '0CH',
  '0CI',
  '0CJ',
  '0CK',
  '0D6',
  '0DC',
  '0EC',
  '0ED',
  '0EE',
  '0EN',
  '0FR',
  '0GD',
  '0GI',
  '0HT',
  '0JH',
  '0KG',
  '0KO',
  '0LL',
  '0LX',
  '0N8',
  '0NS',
  'XB5',
  'XB6',
  'XB7',
  '07X',
  '0CZ',
];

const extraBaggageTypeArray = [
  '0IA', // No cambiar de lugar 0IA afecta la métrica de removeAdmin fee
  '0CC',
  '0CD',
  '0CE',
  '0CF',
  '0CG',
  '0CH',
  '0CI',
  '0CJ',
  '0CK',
  '0EN',
];

const extraBaggageLightTypeArray = [
  '0LX',
  '0JH',
  '0LL',
  '02T',
  'XB5',
  'XB6',
  'XB7',
];

const specialBaggageTypeArray = [
  '0D6',
  '0DC',
  '0HT',
  '0EC',
  '0ED',
  '0EE',
  '0FR',
  '0GD',
  '0GI',
  '0KG',
  '0KO',
  '0NS',
  '0N8',
];

const installmentFeeAncillaries = [
  'M01',
  'M02',
  'M03',
  'M04',
  'M05',
  'M06',
  'M07',
  'M08',
  'M09',
  'M10',
  'M11',
  'M12',
  'M13',
  'M14',
  'M15',
  'M16',
  'M17',
  'M18',
  'M19',
  'M20',
  'M21',
  'M34',
  'M35',
  'M36',
  'M37',
  'M38',
  'M39',
  'M40',
  'M41',
  'MAX',
  'MS1',
  'MS2',
  'MS3',
  'MST',
];

const carryOnBaggageTypeArray = [
  '0MJ',
  '0CZ',
  '07X',
];

const upgradeAncillaries = [
  'UPG',
];
const MAX_BAGS_PER_PASSENGER = 10;

const validateUPG = (flightData, leg) => {
  const travelers = flightData?.pnrInfo?.cart?.travelerCollection;
  if (!travelers ) {
    return;
  }
  
  const allTravelersUPG = travelers.map(traveler=>{
    const ancillaries = traveler.ancillaries.ancillaries;
    
    const { segmentsCollection } = leg;
    const segmentUPG = segmentsCollection.every(segment=>{
      const ancillarieUPG = ancillaries.some(ancillarie=>{
        return segment && segment.segmentCode && ancillarie && ancillarie.segmentCodeAux && segment.segmentCode.substring(0, segment.segmentCode.length - 5) === ancillarie.segmentCodeAux.substring(0, ancillarie.segmentCodeAux.length - 5) && ancillarie.type === 'UPG';
      });
      return ancillarieUPG;
    });
    if (segmentUPG) {
      return traveler;
    }
  });
  if (!flightData?.pnrInfo?.cart?.travelerCollection[0]?.ancillaries?.ancillaries) {
    return;
  }

  return allTravelersUPG.every(element=> element );
};

export {
  ancillaryTypes,
  baggageTypeOptions,
  baggageTypeOptionsInternacional,
  baggageTypes,
  baggageTypesArray,
  carryOnBaggageTypeArray,
  extraBaggageTypeArray,
  extraBaggageLightTypeArray,
  installmentFeeAncillaries,
  specialBaggageTypeArray,
  upgradeAncillaries,
  MAX_BAGS_PER_PASSENGER,
  validateUPG,
};
